import React from 'react';
import PropTypes from 'prop-types';

import ParameterResultCard from '../../../components/ParameterResultCard';
import Divider from '../../../components/Divider';

import { Body1, Heading4 } from '../../../components/Typography';

import './index.scss';

const DoctorDiagnosis = ({ doctorDiagnosis }) => {
  return (
    <div className='doctor-diagnosis'>
      {doctorDiagnosis.map((diagnosis, index) => (
        <div
          key={index}
          id={diagnosis.type}
          className='doctor-diagnosis__section'
        >
          <Divider title={diagnosis.eyebrow} />
          <div className='doctor-diagnosis__section-wrapper'>
            <Heading4 className='doctor-diagnosis__section-title'>
              {diagnosis.title}
            </Heading4>
            <Body1 className='doctor-diagnosis__section-text'>
              {diagnosis.description}
            </Body1>
            <div className='doctor-diagnosis__section-cards'>
              {diagnosis.cards.map((card, cardIndex) => (
                <ParameterResultCard
                  key={cardIndex}
                  title={card.title}
                  text={card.description}
                  regularButtonText={card?.button?.text}
                  regularButtonLink={card?.button?.link}
                  valueType={card.resultType}
                  stringValue={card.resultText}
                  resultBackgroundColor={card.resultBackgroundColor}
                />
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

DoctorDiagnosis.propTypes = {
  doctorDiagnosis: PropTypes.array,
};

export default DoctorDiagnosis;
